export default "__VITE_ASSET__CoU117L3__"